/* eslint-disable */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react-hooks/rules-of-hooks */
import React, { useState, useEffect } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { Grid, Box, Container } from '@material-ui/core';
import { Element, scroller } from 'react-scroll';
import Cookies from 'js-cookie';
import CryptoJS from 'crypto-js';

import AmenitiesAll from '../../Amenities/AmenitiesAll';
import useCommunityList from '../../../../hooks/useCommunityList';
import useAmenities from '../../../../hooks/useAmenities';
import ViewPublic from '../../ViewPublic/ViewPublic';

const ViewAllAmenities = () => {
  const loc = useLocation();
  const params = useParams();
  const key = 'iFrasCwdJh';
  const [communityDetails, setCommunityDetails] = useState(null);
  const { getCommunityBasicInfo } = useCommunityList();
  const amenitiesHook = useAmenities();

  // NOTE: Removed manual fetchAmenities call here because useAmenities hook
  // already auto-fetches when filters change (including initial mount)
  // This was causing duplicate API calls

  let bytes = null;
  let loggedInUserData = null;
  const userCookie = Cookies.get('user');
  const [isAccessible, setIsAccessible] = useState(false);

  if (userCookie) {
    bytes = CryptoJS.AES.decrypt(userCookie, key);
    loggedInUserData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  }
  const [userId] = useState(loggedInUserData?.id);
  const [publicView, setPublicView] = useState(false);

  const fillCommunityDetails = async () => {
    let communityDetailsResults = [];
    if (params?.id) {
      communityDetailsResults = await getCommunityBasicInfo({
        communityId: params?.id,
        userId,
      });
      setCommunityDetails(communityDetailsResults.data);
    }
    return communityDetailsResults?.data;
  };

  const hashFragment = loc.hash.substring(1);

  useEffect(() => {
    // Scroll to Section1 with offset of -100 when component mounts
    if (hashFragment) {
      setTimeout(() => {
        scroller.scrollTo(hashFragment, {
          duration: 500,
          spy: true,
          smooth: true,
          offset: -100,
        });
      }, 1500);
    }
  }, [loc]);

  useEffect(() => {
    fillCommunityDetails();
  }, []);

  useEffect(() => {
    setIsAccessible(
      (loggedInUserData?.id && communityDetails?.userrole?.[0]?.id === loggedInUserData?.id) ||
        loggedInUserData?.roleId === 2,
    );
  }, [communityDetails]);

  return (
    <Box className="ViewAllAmenitiesContainer">
      {communityDetails ? (
        <Box component="div" className="PageSpacing">
          <Container className="CustomContainer">
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="flex-start"
              className="ViewAmenitiesContent"
              spacing={3}
            >
              <Grid item xs={12} sm={12} className="ViewAmenityGrid">
                <Box component="div" className="">
                  <If condition={isAccessible && publicView}>
                    <ViewPublic setPublicView={setPublicView} />
                  </If>

                  <Element name="Section1">
                    <AmenitiesAll
                      communityInfo={communityDetails}
                      isAccessible={isAccessible}
                      publicView={publicView}
                      amenitiesHook={amenitiesHook}
                    />
                  </Element>
                </Box>
              </Grid>
            </Grid>
          </Container>
        </Box>
      ) : (
        <>
          <Container>
            <Grid container className="PageSpacing">
              <Grid item xs={12}>
                No content to display
              </Grid>
            </Grid>
          </Container>
        </>
      )}
    </Box>
  );
};

ViewAllAmenities.defaultProps = {};
export default ViewAllAmenities;
